module.exports = __webpack_public_path__ + "img/balkonverkleidung.f77c381c.webp";